<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="customLoadingOverlay" v-if="jpjLoading">
      <div class="el-loading-mask">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path">
            </circle>
          </svg>
          <!-- <p class="el-loading-text">Proses Semakan SSM Dan JPJ Sedang Dijalankan...</p> -->
          <!-- <img class="loading-logo" style="max-width: 160px; object-fit: contain; z-index: 12;" :src="ssmlogo"/>
          <img class="loading-logo" style="max-height: 80px; object-fit: contain; z-index: 12;" :src="jpjlogo"/> -->
          <img class="loading-logo" style="max-width: 160px; object-fit: contain; z-index: 12;" :src="madani"/>
        </div>
      </div>
    </div>
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1">{{ tajukKad }}</p>
        </div>
        <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
          <el-form-item label="Nama Pemohon/ Wakil" required>
            <el-input
              ref="namaWakil"
              class="el-input-size"
              v-model="namaWakil"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="No. Kad Pengenalan Pemohon/Wakil Syarikat" required>
            <el-input
              ref="noKadPengenalanWakilSyarikat"
              class="el-input-size"
              v-model="noKadPengenalanWakilSyarikat"
              disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="Tarikh" required>
            <el-input
              ref="emel"
              class="el-input-size"
              v-model="today"
              disabled
              >
            </el-input>
          </el-form-item>
        </el-form>
        <div class="cardContent">
          <!-- <el-form ref="userAgreement" :model="userAgreementForm" :rules="userAgreementRules" label-width="200px" class="profileForm" style="width:100%;" v-loading="loading"> -->
            <!-- <el-form-item prop="userAgreement" required> -->
              <el-checkbox-group ref="lockedcheckboxgroup" v-model="userAgreementValue" style="display: flex; flex-direction: column; width: 100%" class="justifyCheckboxes" v-if="locked" disabled>
                <el-checkbox v-for="(userAgreementOption, index) in userAgreementOptions" :key="index" :label="userAgreementOption.value" style="margin-top: 20px">{{ userAgreementOption.label }}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group ref="checkboxgroup" v-model="userAgreementForm.userAgreement" style="display: flex; flex-direction: column; width: 100%" class="justifyCheckboxes" v-else>
                <el-checkbox v-for="(userAgreementOption, index) in userAgreementOptions" :key="index" :label="userAgreementOption.value" style="margin-top: 20px">{{ userAgreementOption.label }}</el-checkbox>
              </el-checkbox-group>
            <!-- </el-form-item> -->
          <!-- </el-form> -->
        </div>
        <!-- <el-button
          v-if="!locked"
          class="el-button-mobile-container"
          type="primary"
          @click="()=>checkUserAgreement()">
          <i class="el-icon-check" style="margin-right: 5px;"/> Hantar
        </el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import ssmlogo from '@/assets/ssm-logo.png'
import jpjlogo from '@/assets/jpj-logo.jpg'
import madani from '@/assets/madani.png'

import moment from 'moment'
export default {
  name: 'akuan-semakan-pengesahan-diesel',
  inheritAttrs: false,
  data() {
    const validateUserAgreement = (rule, value, callback) => {
      if (value.length === this.userAgreementForm.userAgreement.length) {
        callback()
      } else {
        callback(new Error('Sila pilih semua syarat dan terma yang dinyatakan.'))
      }
    }

    return {
      ssmlogo,
      jpjlogo,
      madani,
      faqQuestionOpened: false,
      userAgreementForm: {
        userAgreement: [],
      },
      userAgreementOptions: [
        {
          label: 'Saya adalah wakil syarikat/koperasi yang memohon.',
          value: 'agree1'
        },
        {
          label: 'Saya mengaku dan mengesahkan bahawa maklumat yang saya nyatakan dalam borang ini dan mana-mana lampiran adalah benar dan tidak mengandungi maklumat yang palsu, tidak betul atau mengelirukan. Saya juga faham dan sedar bahawa sekiranya apa-apa maklumat yang diberikan adalah palsu, tidak betul atau mengelirukan, syarikat/koperasi saya boleh disenaraihitamkan atau dibatalkan kelayakan mendapat subsidi dan saya atau syarikat/koperasi saya dikehendaki untuk membayar subsidi yang telah diterima dan saya atau syarikat/koperasi saya boleh dikenakan tindakan undang-undang atau didakwa di bawah mana-mana undang-undang yang berkaitan kerana memberikan maklumat palsu, tidak betul atau mengelirukan tersebut.',
          value: 'agree2'
        },
        {
          label: 'Saya mengesahkan bahawa data yang dikongsi adalah mengikut ketetapan yang dipersetujui oleh semua pihak dan menjaga kerahsiaan dan keselamatan dengan sebaik mungkin, serta mematuhi segala peraturan yang relevan.',
          value: 'agree3'
        }
      ],
      userAgreementValue: [
        'agree1', 'agree2', 'agree3'
      ],
      userAgreementRules: {
        userAgreement: [{ required: true, validator: validateUserAgreement }]
      },
      today: '',
    }
  },
  methods: {
    checkUserAgreement() {
      this.$refs.userAgreement.validate((valid) => {
        if (valid) {
        } else {
          this.$message.error('Sila pilih semua syarat dan terma yang dinyatakan.')
          return false
        }
      })
    },
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    namaWakil: {
      type: String
    },
    noKadPengenalanWakilSyarikat: {
      type: String
    },
    locked: {
      type: Boolean
    },
    allTicked: {
      type: Function
    },
    jpjLoading: {
      type: Boolean
    },
  },
  mounted() {
    this.today = moment().format('DD/MM/YYYY')
  },
  watch: {
    userAgreementForm: {
      handler(newVal) {
        console.log("newVal", newVal.userAgreement.length)
        console.log("this.userAgreementOptions.length", this.userAgreementOptions.length)
        this.allTicked(newVal.userAgreement.length === this.userAgreementOptions.length)
      },
      deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/mydiesel/components/AkuanSemakanPengesahanDiesel.vue